import { render, staticRenderFns } from "./ModalPartnerDeduction.vue?vue&type=template&id=ed54b5d0&scoped=true"
import script from "./ModalPartnerDeduction.vue?vue&type=script&lang=js"
export * from "./ModalPartnerDeduction.vue?vue&type=script&lang=js"
import style0 from "./ModalPartnerDeduction.vue?vue&type=style&index=0&id=ed54b5d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed54b5d0",
  null
  
)

export default component.exports